module.exports = __webpack_public_path__ + "img/EDUCATION.svg";